module.exports = __webpack_public_path__ + "img/login2.976300d8.png";